<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <page-loading v-if="!team"></page-loading>
            <template v-else>
                <team-billing-details
                    v-show="hash === 'billing-details' || !hash"
                    :team="team"
                    :isAdminOrOwner="isAdminOrOwner"
                />

                <team-proforma-invoices
                    v-if="team.status !== 'closed'"
                    v-show="hash === 'proforma-invoices'"
                    :team-id="team.id"
                    :payment-terms-days="team.payment_terms_days"
                />

                <team-historical-invoices v-show="hash === 'historical-invoices'" :team-id="team.id" />
            </template>
        </div>
    </page-container>
</template>

<script setup>
import TeamBillingDetails from './TeamBillingDetails.vue';
import TeamProformaInvoices from './TeamProformaInvoices.vue';
import TeamHistoricalInvoices from './TeamHistoricalInvoices.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import PageLoading from '~/components/general/PageLoading.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import { ref, computed, watch, nextTick, onMounted } from 'vue';
import { useBrowserLocation } from '@vueuse/core';
import axios from '~/services/axios';

const location = useBrowserLocation();
const hash = computed(() => location.value.hash?.replace('#/', '').replace('#', ''));

const content = ref();
const team = ref(null);

const teamId = Spark.state.currentTeam.id;
const isAdminOrOwner = Spark.isAdminOrOwner;

const getTeam = () => {
    axios.get(`/settings/teams/json/${teamId}`).then((response) => {
        team.value = response.data;
    });
};

onMounted(() => {
    getTeam();
});

watch(
    hash,
    async () => {
        await nextTick();
        if (!content.value || window.innerWidth >= 768) {
            return;
        }
        content.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    { immediate: true }
);

Bus.$on('updateTeam', () => {
    getTeam();
});
</script>
